const CHAVE = 'digitacao:regiao';

const obterStore = () => {
    try {
        return window.localStorage;
    } catch (e) {
        return null;
    }
};

const DigitacaoRegiaoStorage = {
    obter: () => {
        const store = obterStore();

        if (!store) return null;

        try {
            return store.getItem(CHAVE) || null;
        } catch (e) {
            return null;
        }
    },

    salvar: regiao => {
        const store = obterStore();

        if (!store) return;

        try {
            if (regiao) store.setItem(CHAVE, regiao);
            else store.removeItem(CHAVE);
        } catch (e) {
            return;
        }
    },

    limpar: () => {
        const store = obterStore();

        if (!store) return;

        try {
            store.removeItem(CHAVE);
        } catch (e) {
            return;
        }
    },
};

export default DigitacaoRegiaoStorage;
